<template>
  <div id="pageIndustries">
    <v-container grid-list-xl fluid>
      <v-btn
        class="btn-add"
        color="white"
        small
        absolute
        fab
        :to="{ name: 'IndustryNew' }"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <br />
      <div class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
          v-if="paginatationDisabled"
        ></v-progress-circular>
      </div>

      <v-card>
        <v-card-text>
          <v-data-table
            v-if="industries.data"
            :headers="headers"
            :items="industries.data"
            :mobile-breakpoint="960"
            disable-pagination
            hide-default-footer
            disable-sort
            dense
          >
            <template v-slot:item.edit="{ item }">
              <v-btn
                :to="{ name: 'IndustryEdit', params: { id: item.id } }"
                small
                icon
              >
                <v-icon size="20">fa-edit</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.remove="{ item }">
              <v-btn @click="deleteIndustryRequest(item)" small icon>
                <v-icon size="20">fa-trash</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.pdf="{ item }">
              <v-switch
                @change="status => handlePdfChange(status, item.id)"
                v-model="item.pdf_notification"
                :value="item.pdf_notification"
                hide-details
              ></v-switch>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <!-- <v-card
        class="card-industry"
        v-for="(industry, index) in industries.data"
        :key="`industry${industry.id}`"
      >
        <v-container>
          <v-layout>
            <v-flex xs2>
              <p style="margin: 6px 0px;">{{ industry.id }}</p>
            </v-flex>
            <v-flex xs3>
              <p style="margin: 6px 0px;">{{ industry.name }}</p>
            </v-flex>
            <v-flex xs7 class="text-xs-right">
              <v-btn
                fab
                small
                :to="{ name: 'IndustryEdit', params: { id: industry.id } }"
                color="primary"
              >
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn
                fab
                small
                color="error"
                @click.stop="deleteIndustryRequest(index)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card> -->

      <app-pagination
        v-if="industries && industries.pagination"
        :pagination="industries.pagination"
        :disabled="paginatationDisabled"
        v-on:change-page="changePage"
      ></app-pagination>
      <app-confirm-modal
        :message="deleteMessage"
        :dialog="dialog"
        :modalType="modalType"
        v-on:choose="deleteIndustry"
      ></app-confirm-modal>

      <v-snackbar
        :timeout="3000"
        bottom
        right
        :color="snackbar.color"
        v-model="snackbar.show"
      >
        {{ snackbar.text }}
        <v-btn dark text @click.native="snackbar.show = false" icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import appApi from "../../plugins/api";
import AppPagination from "../../components/Pagination";
import ConfirmModal from "../../components/ConfirmModal";

export default {
  components: {
    "app-pagination": AppPagination,
    "app-confirm-modal": ConfirmModal
  },
  data: function() {
    return {
      headers: [
        { text: "Id", value: "id", sortable: false },
        { text: "Nome", value: "name", sortable: false },
        { text: "Editar", value: "edit", sortable: false },
        { text: "Excluir", value: "remove", sortable: false },
        { text: "Recebimento de PDF", value: "pdf", sortable: false }
      ],
      industries: {},
      paginatationDisabled: false,
      dialog: false,
      deleteIndustryId: null,
      deleteMessage: "",
      modalType: null,
      snackbar: {}
    };
  },

  computed: {},

  mounted: function() {
    this.getIndustry();
  },

  methods: {
    handlePdfChange(status, id) {
      appApi
        .putIndustryPdfNotification(id, {
          pdf_notification: status || false
        })
        .then(res => {
          this.snackbar = {
            show: true,
            color: "green",
            text: "Atualizado com sucesso."
          };
        });
    },
    redirectIndustry(value) {
      this.$router.push({
        name: "IndustryEdit",
        params: {
          id: value.id
        }
      });
    },
    getIndustry: function(page) {
      this.paginatationDisabled = true;
      this.industries.data = [];
      appApi
        .getIndustries({ page: page ? page : 1 })
        .then(result => {
          this.industries = result.data;
          this.paginatationDisabled = false;
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    changePage(page) {
      this.getIndustry(page);
    },
    deleteIndustryRequest(item) {
      this.dialog = true;
      this.modalType = "error";
      this.industryToDel = item;
      this.deleteMessage = `Tem certeza que deseja deletar <strong>${
        item.name
      }</strong>?`;
    },
    deleteIndustry(confirm) {
      this.dialog = false;
      if (confirm) {
        appApi
          .deleteIndustry(this.industryToDel.id)
          .then(() => {
            this.changePage(1);
            this.snackbar = {
              show: true,
              color: "green",
              text: "Apagado com sucesso."
            };
          })
          .catch(() => {
            this.changePage(1);
            this.snackbar = {
              show: true,
              color: "error",
              text: "Não foi possível apagar."
            };
          });
      }
    }
  }
};
</script>
<style scoped lang="css">
#pageIndustries {
  position: relative;
}
#pageIndustries .btn-add {
  position: fixed;
  top: 90px;
  left: calc(100% - 60px);
}
#pageIndustries .card-industry {
  margin-bottom: 10px;
}
</style>
